import { useSelector } from 'react-redux';
// TODO: fix sibling slice import
import { catalogLayoutActiveItemIdSelector } from 'src/features/catalog';

export const useActiveCatalogItemId = (): number | undefined => {
  return useSelector(catalogLayoutActiveItemIdSelector);
};
